import type { PlayerSeasonStatRow } from '../../../../services/player/playerSeasonStats'
import type { StatColumn } from '../types'

const startsAtMs = (row: PlayerSeasonStatRow): number | null => {
  const raw = row.season?.starts_at
  if (!raw) {
    return null
  }
  const ms = Date.parse(raw)
  return Number.isNaN(ms) ? null : ms
}

export const sortSeasonRowsNewestFirst = (
  rows: PlayerSeasonStatRow[]
): PlayerSeasonStatRow[] =>
  rows
    .map((row, index) => ({ row, index, ms: startsAtMs(row) }))
    .sort((a, b) => {
      if (a.ms === null && b.ms === null) {
        return a.index - b.index
      }
      if (a.ms === null) {
        return 1
      }
      if (b.ms === null) {
        return -1
      }
      return b.ms - a.ms || a.index - b.index
    })
    .map(({ row }) => row)

export const buildStatColumns = (rows: PlayerSeasonStatRow[]): StatColumn[] => {
  const columns: StatColumn[] = []
  const indexByAbbr = new Map<string, number>()

  sortSeasonRowsNewestFirst(rows).forEach((row) => {
    row.stats?.forEach((stat) => {
      const abbr = stat.abbr ?? stat.type?.abbr
      if (!abbr) {
        return
      }
      const name = stat.name || stat.type?.name || ''
      const existing = indexByAbbr.get(abbr)
      if (existing === undefined) {
        indexByAbbr.set(abbr, columns.length)
        columns.push({ abbr, name: name || abbr })
      } else if (columns[existing].name === abbr && name) {
        columns[existing] = { abbr, name }
      }
    })
  })

  return columns
}
